import React from "react";

const InvalidBarcodeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="invalid-barcode-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-icon">
          <div className="error-icon">✕</div>
        </div>
        
        <h2 className="modal-title">Invalid Barcode</h2>
        <p className="modal-message">
          No product found for the scanned barcode. Please try again or
          check the code.
        </p>
        <button className="modal-ok-btn" onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default InvalidBarcodeModal;
